I18n.translations.ES = {
	loading: 'cargando...',
	developed_by: 'Desarrollado para All Flamenco por',
	back: 'Volver',
	yes: 'Si',
	no: 'No',
	ok: 'OK',
	connection_error: 'Problemas de conexión',
	connection_down: 'Ha ocurrido un error relacionado con tu conexión a Internet.',
	connection_up: 'La conexión a Internet se ha restablecido.',
	error: 'Error:',
	timeout: 'Se agotó el tiempo de espera de respuesta.',
	player_error: 'Error:',
	err_config_fetch: 'Es imposible cargar la configuración de la API.',
	err_throbber_timeout: 'Algo está tardando demasiado. Por favor, intente nuevamente luego de unos minutos.',
	playback_error_message: 'Ha ocurrido un error relacionado a la reproducción de video.',
	please_sign_in: 'Identificate para ingresar a tu cuenta',
	enter_your_email: 'Escriba su correo electrónico',
	enter_your_password: 'Escriba su contraseña',
	email: 'E-MAIL',
	password: 'Contraseña',
	continue: 'Seguir',
	skip_this_step: 'Saltear este paso',
	not_registred_yet: '¿Todavía no está asociado?',
	please_go_to: 'Suscríbase en',
	lets_watch: 'Vamos a ver',
	invalid_credentials: 'La cuenta no existe.',
	invalid_email: 'Ingrese un email válido por favor.',
	invalid_password: 'Ingrese una contraseña válida por favor.',
	full_description: 'Detalle de la obra',
	close_description: 'Cerrar descripción',
	go_back: 'Volver',
	sign_in: "Ingresar",
    sign_out: "Cerrar sesión",
	min: 'min',
	no_Url: 'Falta la Url',
	err_data_fetch: 'La búsqueda de datos ha fallado.',
	dialog_exit_title: 'Salir',
	dialog_exit_content: '¿Quiere salir de la aplicación?',
	token_expired:"Tu sesión de acceso ha caducado, inicia sesión.",
    issue_login:"Si tenés inconvenientes para utlizar la app comunicate de lunes a viernes de 9 a 18hs por mail a: subscribers@allflamenco.net.",
	search: "Buscar por título, actor, director o autor",
	search_title: "Buscar",
    results: 'Resultados de "',
	go_back_catalog: 'Volver al catálogo',
	my_account: 'MI CUENTA',
	login_title: 'Inicia sesión a través de un explorador',
	login_line1: 'En tu smartphone o PC entra a ',
	login_line2: 'Inicia sesión o regístrate en ALL FLAMENCO',
	login_line3: 'Ingrese el siguiente código',
	name: 'NOMBRE',
	session: 'SESIÓN',
	subscription: 'Suscripción',
	no_subscription: 'Aún no tienes una SUSCRIPCIÓN a ALL FLAMENCO',
	spacebar: 'Espacio',
	play: 'Reproducir',
	add_favorites: 'Agregar a favoritos',
	remove_favorites: 'Eliminar de favoritos',
	favorites: 'Favoritos',
	continue_watching: 'Continuar viendo',
	requires_subscription: 'Título de alquiler no incluido en su plan. Primero debe realizar su contratación desde un navegador, entrando en app.allflamenco.net<br/>A continuación, podrá verlo aquí.',
	detail_ARTISTS: 'ARTISTAS',
	detail_YEAR: 'AÑO PRODUCCIÓN',
	detail_RATING: 'CLASIFICACIÓN EDADES',
	detail_STYLE: 'ESTILO MUSICAL',
	detail_GENRE: 'GÉNERO',
	detail_LANGUAGE: 'IDIOMA',
	detail_LOC_CITY: 'LOCALIDAD',
	detail_LOC_PLACE: 'LOCALIZACIÓN',
	detail_TYPE: 'TIPO',
	detail_SEASON: 'TEMPORADA',
	detail_EPISODE: 'EPISODIO',
	detail_SERIES: 'Serie', 
	detail_DURATION: 'DURACIÓN',
	detail_DESCRIPTION: 'SINOPSIS',
	purchases: 'COMPRAS',
	sub_active: 'Suscripción activa',
	sub_inactive: 'Usted no tiene una suscripción activa, por favor ingrese a app.allflamenco.net',

}


//////////////////
// WEBPACK FOOTER
// ./js/i18n/es.js
// module id = 41
// module chunks = 0